// Returns true when app is running in development mode
const isDevelopment = () => process.env.NODE_ENV === 'development'

export default isDevelopment
